module.exports = __webpack_public_path__ + "img/tif.4e4712d4.svg";